import { GameState } from '../gameState/types';
import { StateChangeEvent } from '../stateChangeEvent/types';
import { GameManager } from './types';

export function createGameManager(
	gameId: number,
	initState: GameState,
	stateChangeHistory: StateChangeEvent[]
): GameManager {
	const gameState = initState;
	const lastSaved = Date.now();

	return {
		gameId,
		initState,
		gameState,
		stateChangeHistory,
		lastSaved,
	};
}
